/**
 * Semantic tone classes backed by the 7barber Design System tokens.
 *
 * Project rule: do not use inline styles or external CSS frameworks in JSX.
 */

export type Tone =
  | 'blue'
  | 'green'
  | 'amber'
  | 'indigo'
  | 'red'
  | 'purple'
  | 'admin'
  | 'muted';

interface ToneClasses {
  bg: string;
  fg: string;
  border: string;
  borderSubtle: string;
  ring: string;
  solid: string;
}

export const TONES: Record<Tone, ToneClasses> = {
  blue: {
    bg: 'tone-bg tone-bg--blue',
    fg: 'tone-fg tone-fg--blue',
    border: 'tone-border tone-border--blue',
    borderSubtle: 'tone-border-subtle tone-border-subtle--blue',
    ring: 'tone-ring tone-ring--blue',
    solid: 'tone-solid tone-solid--blue',
  },
  green: {
    bg: 'tone-bg tone-bg--green',
    fg: 'tone-fg tone-fg--green',
    border: 'tone-border tone-border--green',
    borderSubtle: 'tone-border-subtle tone-border-subtle--green',
    ring: 'tone-ring tone-ring--green',
    solid: 'tone-solid tone-solid--green',
  },
  amber: {
    bg: 'tone-bg tone-bg--amber',
    fg: 'tone-fg tone-fg--amber',
    border: 'tone-border tone-border--amber',
    borderSubtle: 'tone-border-subtle tone-border-subtle--amber',
    ring: 'tone-ring tone-ring--amber',
    solid: 'tone-solid tone-solid--amber',
  },
  indigo: {
    bg: 'tone-bg tone-bg--indigo',
    fg: 'tone-fg tone-fg--indigo',
    border: 'tone-border tone-border--indigo',
    borderSubtle: 'tone-border-subtle tone-border-subtle--indigo',
    ring: 'tone-ring tone-ring--indigo',
    solid: 'tone-solid tone-solid--indigo',
  },
  red: {
    bg: 'tone-bg tone-bg--red',
    fg: 'tone-fg tone-fg--red',
    border: 'tone-border tone-border--red',
    borderSubtle: 'tone-border-subtle tone-border-subtle--red',
    ring: 'tone-ring tone-ring--red',
    solid: 'tone-solid tone-solid--red',
  },
  purple: {
    bg: 'tone-bg tone-bg--purple',
    fg: 'tone-fg tone-fg--purple',
    border: 'tone-border tone-border--purple',
    borderSubtle: 'tone-border-subtle tone-border-subtle--purple',
    ring: 'tone-ring tone-ring--purple',
    solid: 'tone-solid tone-solid--purple',
  },
  admin: {
    bg: 'tone-bg tone-bg--admin',
    fg: 'tone-fg tone-fg--admin',
    border: 'tone-border tone-border--admin',
    borderSubtle: 'tone-border-subtle tone-border-subtle--admin',
    ring: 'tone-ring tone-ring--admin',
    solid: 'tone-solid tone-solid--admin',
  },
  muted: {
    bg: 'tone-bg tone-bg--muted',
    fg: 'tone-fg tone-fg--muted',
    border: 'tone-border tone-border--muted',
    borderSubtle: 'tone-border-subtle tone-border-subtle--muted',
    ring: 'tone-ring tone-ring--muted',
    solid: 'tone-solid tone-solid--muted',
  },
};

export function toneChip(t: Tone): string {
  return `tone-chip tone-chip--${t}`;
}

export function toneBg(t: Tone): string {
  return TONES[t].bg;
}

export function toneFg(t: Tone): string {
  return TONES[t].fg;
}

export function toneCard(t: Tone): string {
  return `tone-card tone-card--${t}`;
}

export function toneSolid(t: Tone): string {
  return TONES[t].solid;
}
